import {Table} from 'src/feature/bite/component/Table'
import {Overlay, Tooltip} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useTerminal} from '../../hook'
import {useState, useMemo, useRef} from 'react'

// const types = {
//   99: 'CartReward',
//   0: "Complete",
//   88: "Cancel",
//   2: "Return"
// }

const Detail = ({isLoading}: {isLoading: boolean}) => {
  const intl = useIntl()

  const {detail, detailSet} = useTerminal()
  const [tokenOverlay, setTokenOverlay] = useState(false)
  const [hideToken, setHideToken] = useState(true)
  const tokenEl = useRef(null)

  const splitToken = useMemo(() => {
    if (detail?.tokenCode) {
      const token = detail?.tokenCode
      if (token.length > 8) return token.slice(0, 4) + '****' + token.slice(-4)
      else return token
    }
    return ''
  }, [detail?.tokenCode])

  const Data = detail?.transactionDetails || []
  const Paging = detail?.detailsPaging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'OrderId',
      dataIndex: 'orderId',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.ORDER_ID'}),
    },
    {
      key: 'Date',
      dataIndex: 'date',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.DATE_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'TerminalId',
      dataIndex: 'terminalId',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.TERMINAL_ID'}),
      render: (text: string | null) => {
        return <>{!text ? '-' : text}</>
      },
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.TYPE'}),
      render: (text: string) => {
        let color = 'text-success'

        switch (text) {
          case 'Cancel':
            color = 'text-error'
            break
          case 'Refund':
            color = 'text-refund'
            break
          case 'Sale':
            color = 'text-success'
            break
          case 'SignUp':
            color = 'text-signup'
            break
          case 'Birthday':
            color = 'text-info'
            break
          default:
            color = 'text-success'
            break
        }

        return <span className={color}>{text}</span>
      },
    },
    {
      key: 'Amount',
      dataIndex: 'paidAmount',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.AMOUNT'}) + ' (AED)',
      customMonetize: true,
    },
    {
      key: 'Channel',
      dataIndex: 'channel',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.CHANNEL'}),
    },
    {
      key: 'StoreId',
      dataIndex: 'storeNo',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.STORE_ID'}),
    },
    {
      key: 'orderId',
      dataIndex: 'transactionId',
      title: intl.formatMessage({id: 'TERMINAL.DETAIL.ACTION'}),
      render: (id: string) => (
        <a href={`/transaction/${id}`}>{intl.formatMessage({id: 'TERMINAL.DETAIL.DETAIL'})}</a>
      ),
    },
  ]

  return (
    <div className='row mt-10'>
      <div className='col col-lg-3'>
        <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
          {isLoading && (
            <div
              style={{
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                background: 'rgb(255 255 255 / 76%)',
              }}
            >
              {intl.formatMessage({id: 'LOADING'})}...
            </div>
          )}

          <div className='card-header'>
            <div className='card-title m-0'>
              <h3 className='fw-bold m-0'>
                {intl.formatMessage({id: 'TERMINAL.DETAIL.TERMINAL_INFORMATION'})}
              </h3>
            </div>
          </div>

          <div className='card-body p-9'>
            <div className='col-md-12'>
              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.DEVICE_MODEL'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.deviceModel}</span>
                </div>
              </div>
              {/*
              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.MANUFACTURER'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.manufacturer}</span>
                </div>
              </div>
              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.DEVICE_OS'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.deviceOS}</span>
                </div>
              </div> */}

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.DEVICE_LABEL'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.deviceLabel}</span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.SERIAL_NUMBER'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.serialNumber}</span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.LAST_TRANSACTION'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>
                    {getDateAndTime(detail?.lastTransactionDate || '')}
                  </span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.ONE_TIME_PASSCODE'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.oneTimePasscode}</span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.ASSIGNED_BUILD_NUMBER'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>
                    {detail?.assignedBuildNumber}
                  </span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.APPLICATION_SIGN'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.applicationSign}</span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.BUILD_NUMBER'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.buildNumber}</span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.MCC'})}
                </label>

                <div className='col-lg-8'>
                  <span className='fw-semibold fs-6 text-gray-800'>{detail?.mccCode}</span>
                </div>
              </div>

              <div className='row mb-10'>
                <label className='col-lg-4 fw-semibold text-muted'>
                  {intl.formatMessage({id: 'TERMINAL.INPUT.TOKEN_CODE'})}
                </label>

                <div className='col-lg-8'>
                  {detail?.tokenCode ? (
                    splitToken?.length > 8 ? (
                      <>
                        <>
                          <span className='fw-semibold fs-6 text-gray-800'>
                            {hideToken ? splitToken : detail?.tokenCode}
                          </span>
                          <i
                            className={
                              tokenOverlay
                                ? 'fas fa-eye-slash ms-1 cursor-pointer'
                                : 'fas fa-eye ms-1 cursor-pointer'
                            }
                            ref={tokenEl}
                            onClick={() => setTokenOverlay(!tokenOverlay)}
                          />
                          <Overlay target={tokenEl.current} show={tokenOverlay} placement='top'>
                            {(props) => (
                              <Tooltip id='overlay-example' {...props}>
                                {detail?.tokenCode}
                              </Tooltip>
                            )}
                          </Overlay>
                        </>
                      </>
                    ) : (
                      <>{splitToken || '-'}</>
                    )
                  ) : (
                    '-'
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <div className='card-footer d-flex w-100 justify-content-end'>
            <a className='btn btn-primary' href={`/terminals/${detail?.terminalId}/edit`}>
              <i className='bi bi-pencil me-2'></i>
              {intl.formatMessage({id: 'TERMINAL.DETAIL.EDIT'})}
            </a>
          </div> */}
        </div>
      </div>
      <div className='col col-lg-9'>
        <div className='card'>
          <div className='card-header'>
            <div className='card-title m-0'>
              <h3 className='fw-bold m-0'>
                {intl.formatMessage({id: 'TERMINAL.DETAIL.TRANSACTION'})}
              </h3>
            </div>
          </div>

          <div className='card-body pt-0'>
            {/* <Table tableData={tableData} tableOptions={tableOptions} type='transaction' /> */}
            <Table
              loading={false}
              dataSource={Data}
              columns={Columns}
              pagination={{
                current: Paging.currentPageNumber,
                pageSize: Paging.pageSize,
                total: Paging.totalCount,
                onChange: (page: any) => {
                  if (!detail || !detail.detailsPaging) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== detail.detailsPaging.pageSize ? 1 : current

                  detailSet({
                    ...detail,
                    detailsPaging: {
                      ...detail.detailsPaging,
                      currentPageNumber: currentPage,
                      pageSize: page.pageSize,
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Detail
